import type { CalcResult } from '@/domain/types'

export function SuggestionSection({ result }: { result: CalcResult }) {
  const { suggestion } = result
  return (
    <section className="card border-2 border-brand-200 bg-brand-50/40">
      <h2 className="section-title">填报建议</h2>
      {suggestion.first && (
        <div className="mb-3">
          <div className="text-ink-500 text-sm mb-1">第一志愿</div>
          <div className="text-h2 text-brand-800">{suggestion.first}</div>
        </div>
      )}
      {suggestion.second && (
        <div className="mb-3">
          <div className="text-ink-500 text-sm mb-1">第二志愿</div>
          <div className="text-h3 text-brand-700">{suggestion.second}</div>
        </div>
      )}
      <p className="text-ink-700 leading-relaxed">{suggestion.rationale}</p>
      <div className="mt-4 px-3 py-2.5 bg-amber-50 text-amber-800 text-sm rounded-lg leading-relaxed">
        本建议为模型基于公开规则的辅助参考，最终填报请结合本年度公告、孩子意愿与老师建议综合决定。
      </div>
    </section>
  )
}
